import React from 'react';
import { crmUi } from '../../../../constants/Endpoint';
import { Cell, EditCell, DeleteCell } from '../../../generic/AsTable/Standard';
import { tableCellStyle } from '../CampaignBriefStyles';

const cellStyle = {
    ...tableCellStyle,
    justifyContent: 'flex-start',
    paddingLeft: 10
};

const CampaignContactsDataRow = ({
    entity = {},
    index,
    scrollPx,
    onHover,
    isHighlighted,
    rowHeight,
    visibleRows,
    readOnly,
    hideEditable = false,
    onEdit,
    onDeleteClick
}) => {
    /**
     * mouseEnter event handler for all cells in this row
     * used for row highlighting and dragging
     * @param {Event} event - event
     */
    const onMouseEnter = (event) => {
        typeof onHover === 'function' && onHover(index);
    };

    /**
     * mouseLeave event handler for all cells in this row
     * @param {Event} event - event
     */
    const onMouseLeave = (event) =>
        typeof onHover === 'function' && onHover(-1);

    const handleEditClick = () => {
        entity.index = index;
        onEdit(entity);
    };

    const handleDeleteClick = () => {
        onDeleteClick(entity);
    };

    const handleLinkClick = () => {
        window.open(
            `${crmUi}/contacts/details/?contactId=${entity?.contact?.id}&campaignId=${entity?.campaignId}&readonly=false&source=campaign-manager`,
            '_self'
        );
    };

    return (
        <>
            <EditCell
                area={`i${index}`}
                rowHeight={rowHeight}
                scrollPx={scrollPx}
                index={index}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
                isHighlighted={isHighlighted}
                visibleRows={visibleRows}
                disabled={hideEditable || readOnly}
                style={{ borderWidth: '0 1px 1px 1px' }}
                onClick={handleEditClick}
            />
            <DeleteCell
                area={`ii${index}`}
                rowHeight={rowHeight}
                scrollPx={scrollPx}
                index={index}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
                onClick={handleDeleteClick}
                isHighlighted={isHighlighted}
                visibleRows={visibleRows}
                disabled={hideEditable || readOnly}
            />
            <Cell
                area={`name${index}`}
                rowHeight={rowHeight}
                scrollPx={scrollPx}
                index={index}
                onClick={handleLinkClick}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
                isHighlighted={isHighlighted}
                visibleRows={visibleRows}
                style={{
                    ...cellStyle,
                    color: '#1101BE',
                    fontWeight: 600,
                    cursor: 'pointer'
                }}
            >
                {entity?.contact?.fullName}
            </Cell>
            <Cell
                area={`account${index}`}
                rowHeight={rowHeight}
                scrollPx={scrollPx}
                index={index}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
                isHighlighted={isHighlighted}
                visibleRows={visibleRows}
                style={cellStyle}
            >
                {entity?.contact?.account?.name}
            </Cell>
            <Cell
                area={`email${index}`}
                rowHeight={rowHeight}
                scrollPx={scrollPx}
                index={index}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
                isHighlighted={isHighlighted}
                visibleRows={visibleRows}
                style={cellStyle}
            >
                {entity?.contact?.emailWork}
            </Cell>
            <Cell
                area={`mobile${index}`}
                rowHeight={rowHeight}
                scrollPx={scrollPx}
                index={index}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
                isHighlighted={isHighlighted}
                visibleRows={visibleRows}
                style={cellStyle}
            >
                {entity?.contact?.mobileNumber}
            </Cell>
            <Cell
                area={`role${index}`}
                rowHeight={rowHeight}
                scrollPx={scrollPx}
                index={index}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
                isHighlighted={isHighlighted}
                visibleRows={visibleRows}
                style={cellStyle}
            >
                {entity?.contactRole?.name}
            </Cell>
        </>
    );
};

export default CampaignContactsDataRow;
